export default __webpack_public_path__ + "static/media/CivilEng_IMG-PipeJacking.be3e4c2a.png";